module.exports = __webpack_public_path__ + "static/media/drvm-inactive.7c684dbb.png";